<template>
  <div>
    <megabit-base-dialog :show-dialog="true">
      <template v-slot:body>
        <v-card dark>
          <v-card-title class="align-self-center">
            <span class="text-h6 white--text"
              >{{
                $t('title-forms.cadastro', { nome: $t('menu-home.usuario') })
              }}
              (alt+r)</span
            >
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="formValid">
              <v-row>
                <v-col cols="12" sm="4">
                  <base-input
                    :label="$t('labels.codigo')"
                    :placeholder="$t('labels.codigo')"
                    persistent-hint
                    v-model="form.codigo"
                    :min-length="1"
                    :max-length="9"
                  />
                </v-col>
                <v-col cols="12" sm="8">
                  <base-input
                    :label="$t('labels.nome')"
                    :placeholder="$t('labels.nome')"
                    persistent-hint
                    v-model="form.nome"
                    :min-length="4"
                    :max-length="20"
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <base-input
                    :label="$t('labels.nomeCompleto')"
                    :placeholder="$t('labels.nomeCompleto')"
                    persistent-hint
                    v-model="form.nomeCompleto"
                    :min-length="4"
                    :max-length="50"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <form-buttons @goBack="goBack()" @submitForm="validateForm()" />
        </v-card>
      </template>
    </megabit-base-dialog>
  </div>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import BaseInput from '@/components/shared/base-input/BaseInput'
import { mapActions, mapState } from 'vuex'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
export default {
  components: { 'megabit-base-dialog': BaseDialog, BaseInput, FormButtons },
  data: () => {
    FormButtons
    return {
      cardTitle: '',
      formValid: false,
      isUpdate: false,
      codigo: '',
      form: {
        codigo: '',
        nome: '',
        nomeCompleto: '',
      },
    }
  },
  computed: {
    ...mapState('userModule', ['user', 'loadingItems']),
  },
  methods: {
    ...mapActions({
      getUserAPI: 'userModule/getUserAPI',
      updateUserAPI: 'userModule/updateUserAPI',
      insertUserAPI: 'userModule/insertUserAPI',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setMessage: 'dialogModule/setLoadingDialogMessage',
    }),
    convertObject() {
      let newObject = {}

      Object.keys(this.form).forEach((key) => {
        newObject[key.toUpperCase()] = this.form[key]
      })

      return newObject
    },
    async validateForm() {
      try {
        this.setMessage(this.$t('messages.enviarRegistro'))
        this.showLoadingDialog(true)
        if (this.$refs.form.validate()) {
          let user = this.convertObject()

          let response
          if (this.isUpdate)
            response = await this.updateUserAPI({
              data: user,
              codigo: this.codigo,
            })
          else response = await this.insertUserAPI(user)
          this.$toasted.success(response)
          this.$router.push({ name: this.$route.matched[0].name })
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    goBack() {
      this.$router.push({ name: this.$route.matched[0].name })
    },
    async mountData() {
      try {
        if (this.$route.params.id > 0) {
          await this.getUserAPI(this.$route.params.id)
          this.form.codigo = this.user.CODIGO
          this.codigo = this.user.CODIGO
          this.form.nome = this.user.NOME
          this.form.nomeCompleto = this.user.NOMECOMPLETO
          this.isUpdate = !this.isUpdate
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  mounted() {
    this.mountData()
  },
}
</script>

<style></style>
